'use strict';

export default class EventEmitter {
    constructor() {
        this.events = {};
    }

    on(event, listener) {
        if (!Array.isArray(this.events[event])) {
            this.events[event] = [];
        }

        this.events[event].push(listener);
    }

    once(event, listener) {
        const wrapper = (...args) => {
            this.removeListener(event, wrapper);
            listener(...args);
        };

        this.on(event, wrapper);
    }

    off(event, listener) {
        this.removeListener(event, listener);
    }

    removeListener(event, listener) {
        if (Array.isArray(this.events[event])) {
            const idx = this.events[event].indexOf(listener);
            if (idx >= 0) {
                this.events[event].splice(idx, 1);
            }
        }
    }

    removeAllListener(event) {
        if (event === undefined) {
            this.events = {};
        } else if (Array.isArray(this.events[event])) {
            this.events[event] = [];
        }
    }

    emit(event, ...args) {
        if (Array.isArray(this.events[event])) {
            for (const listener of this.events[event]) {
                listener(...args);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/EventEmitter.js